import { useCallback, useEffect, useState } from 'react';

type UseScenarioWorkspaceInputsOptions = {
    scenarioId: number | null;
    enabled?: boolean;
};

export const useScenarioWorkspaceInputs = ({
    scenarioId,
    enabled = true,
}: UseScenarioWorkspaceInputsOptions) => {
    const [hasUserInputs, setHasUserInputs] = useState(false);

    // TODO: Drive `hasUserInputs` from KPI table edits via `markUserInputsDirty` / `onUserInputChange`.

    useEffect(() => {
        setHasUserInputs(false);
    }, [scenarioId]);

    const markUserInputsDirty = useCallback(() => {
        if (!enabled) {
            return;
        }
        setHasUserInputs(true);
    }, [enabled]);

    const clearUserInputs = useCallback(() => {
        setHasUserInputs(false);
    }, []);

    return {
        hasUserInputs,
        markUserInputsDirty,
        clearUserInputs,
    };
};

export default useScenarioWorkspaceInputs;
